import Hinge from './hinge'
import RollIn from './roll-in'
import RollOut from './roll-out'
import RollInOut from './roll-in-out'

export default {
  Hinge,
  RollIn,
  RollOut,
  RollInOut
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/specials/index.js